import React from "react";
import { prepareSelectorHOC } from "../../../../hoc/prepareSelectorHOC";
import uuid from "../../../../utils/uuid";

import BtnClear from "../../param-table-editor-dialog/btn-clear";
import IntervalSelectorGraph from "./interval-selector-graph/interval-selector-graph";
import "./graph-selector.scss";

const IntervalSelector = props => {
    const { channel, loc, channelNames, onChanged } = props;
    const { S, P, QTmax, PDur } = props.data;

    const onChannelChanged = ({ index }) => {
        const { changeSettings } = props;
        changeSettings({ channel: index });
    };

    const onClear = key => {
        const { onChanged } = props;
        onChanged({ [key]: null });
    };

    const options = channelNames.map(name => (
        <option value={name} key={uuid()}>
            {name}
        </option>
    ));
    const ms = loc("units.ms");
    const captTexts = [`PQ:`, `P↔:`, `QRS:`, `QT:`];
    const valsTexts = [
        P !== null ? `${-P} ${ms}` : "\u00A0",
        PDur !== null ? `${PDur} ${ms}` : "\u00A0",
        `${S} ${ms}`,
        QTmax !== null ? `${QTmax} ${ms}` : "\u00A0"
    ];
    const clearable = [P !== null, PDur !== null, false, QTmax !== null];

    return (
        <>
            <div className="graph-selector__toolbar">
                <div className="graph-selector__toolbar-lead">
                    <label>{loc("dialogs.intervalSelector.lead")}</label>
                    <select
                        className="ctrl-input graph-selector__Lead"
                        value={channelNames[channel]}
                        onChange={({ target: { selectedIndex: index } }) => onChannelChanged({ index })}>
                        {options}
                    </select>
                </div>
                <div className="graph-selector__toolbar-valueText">
                    <div className="valueText">
                        <div className="valueText__column valueText__column_caption ">
                            <p className="valueText__str">{captTexts[0]}</p>
                            <p className="valueText__str">{captTexts[2]}</p>
                        </div>
                        <div className="valueText__column valueText__column_text">
                            <div className="ctrl-input-group">
                                <p className="valueText__str">{valsTexts[0]}</p>
                                {clearable[0] && <BtnClear onClick={e => onClear("P")} />}
                            </div>
                            <p className="valueText__str">{valsTexts[2]}</p>
                        </div>
                        <div className="valueText__column valueText__column_caption ">
                            <p className="valueText__str">{captTexts[1]}</p>
                            <p className="valueText__str">{captTexts[3]}</p>
                        </div>
                        <div className="valueText__column valueText__column_text ">
                            <div className="ctrl-input-group">
                                <p className="valueText__str">{valsTexts[1]}</p>
                                {clearable[1] && (
                                    <BtnClear
                                        onClick={e => {
                                            onClear("PDur");
                                        }}
                                    />
                                )}
                            </div>
                            <div className="ctrl-input-group">
                                <p className="valueText__str">{valsTexts[3]}</p>
                                {clearable[3] && (
                                    <BtnClear
                                        onClick={e => {
                                            onClear("QTmax");
                                        }}
                                    />
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div
                className={["graph-selector", P == null && "noP", PDur == null && "noPDur", QTmax == null && "noT"]
                    .filter(Boolean)
                    .join(" ")}>
                <IntervalSelectorGraph userSweepUnits={loc("units.mm_sec")} data={props.data} onChanged={onChanged} />
            </div>
        </>
    );
};

export default prepareSelectorHOC(IntervalSelector);
